import { ThemeProvider, createTheme } from '@mui/material';
import { createRoot } from 'react-dom/client';
import App from './App';
import store from './app/store';
import BlockSkeletonUi from './components/block-skeleton-ui/BlockSkeletonUi';
import './i18n';
import HttpService from './services/httpService/HttpService';
import UserService from './services/userService/UserService';

const theme = createTheme();

const AppWrapper = () => (
    <ThemeProvider theme={theme}>
        <div style={{ height: '100%', display: 'flex', alignItems: 'center', flexDirection: 'column' }}>
            <BlockSkeletonUi />
        </div>
    </ThemeProvider>
);

const root = createRoot(document.getElementById('root'));

const renderApp = () => root.render(<App />);

UserService.initKeycloak(renderApp);
HttpService.configure();

root.render(<AppWrapper />);
